import clsx from "clsx";
import React from "react";

import { toast } from "~/helpers/toaster.client";

interface Props {
  children: React.ReactNode,
  className?: string | null,
}

const Code: React.FC<Props> = (
  {
    children,
    className = null
  }
) => {
  const copyToClipBoard = async (copyMe: React.ReactNode) => {
    if (!copyMe) {
      return;
    }

    let str: string;
    switch (true) {
      case Array.isArray(copyMe):
        str = copyMe.join("");
        break;
      default:
        str = copyMe.toString();
    }

    try {
      await navigator.clipboard.writeText(str);
      toast("Copied to clipboard!");
    } catch (err) {
      toast("Failed to copy to clipboard");
    }
  };

  return (
    <code
      className={clsx(
        "bg-slate-300 dark:bg-slate-700 py-1 px-2 rounded-md cursor-pointer",
        className
      )}
      onClick={() => copyToClipBoard(children)}
    >
      {children}
    </code>
  )
    ;

};

export default Code;
